module.exports = __webpack_public_path__ + "static/media/twitter-black.a5f73333.svg";